/**
 * Checkout cancel landing.
 *
 * User dismissed the Stripe Checkout without paying. No mutation happens
 * on our side — Stripe simply redirects here.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

import { Button } from '../components/ui/button';

export default function BillingCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-6"
         data-testid="billing-cancel-page">
      <div className="max-w-lg w-full rounded-2xl border border-neutral-200 bg-white p-10 text-center shadow-sm">
        <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-neutral-100 mb-4">
          <XCircle className="h-7 w-7 text-neutral-500" />
        </div>
        <h1 className="text-2xl font-semibold text-neutral-900"
            data-testid="billing-cancel-heading">
          Checkout cancelled.
        </h1>
        <p className="mt-2 text-neutral-600">
          No charge was made. You can pick a plan again whenever you&apos;re ready.
        </p>
        <div className="mt-8 flex flex-col gap-2">
          <Button
            className="w-full h-11"
            onClick={() => navigate('/pricing')}
            data-testid="billing-cancel-back-to-pricing-btn"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to pricing
          </Button>
          <button
            type="button"
            className="text-sm text-neutral-500 hover:text-neutral-800 underline underline-offset-2"
            onClick={() => navigate('/dashboard')}
            data-testid="billing-cancel-dashboard-link"
          >
            Continue to dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
